import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource, requestCameraPermissions, requestGalleryPermissions } from '@core/capacitor-plugins/capacitor-plugins.class';
import { PermissionState } from '@shared/constants';

@Injectable()
export class CameraService {
  async takePhoto(source: CameraSource, size?: { width: number; height: number }): Promise<string> {
    const width: number = size?.width ?? 1024;
    const height: number = size?.height ?? 1024;
    const photo = await Camera.getPhoto({
      source,
      resultType: CameraResultType.Base64,
      saveToGallery: false,
      quality: 50,
      correctOrientation: true,
      width,
      height,
    });

    if (!photo.base64String) {
      throw new Error('No base64 data');
    }
    return photo.base64String;
  }

  requestPermissions(source: CameraSource): Promise<boolean> {
    if (source === CameraSource.Photos) {
      return requestGalleryPermissions().then((status) => status === PermissionState.granted);
    }
    return requestCameraPermissions().then((status) => status === PermissionState.granted);
  }
}
